<template>
  <Sort
    :options="options"
    :sort-key="options[0].key"
    selected-value="おすすめ順"
  />
</template>
<script>
import Sort from '../../components/atoms/sorts/Sort.vue'
export default {
  components: { Sort },
  data() {
    return {
      options: [
        { key: 'おすすめ順', value: 'おすすめ順' },
        { key: '価格が安い順', value: '価格が安い順' },
        { key: '価格が高い順', value: '価格が高い順' }
      ]
    }
  }
}
</script>
